export const TIME_TRAVELLER_ATOM = '/common/TIME_TRAVELLER_ATOM';
